<ng-template #tableTools>
  <button type="button" class="btn btn-primary" style="color: white !important;"
  (click)="addVoice()">Add Voice</button>
</ng-template>

@if ((voiceService.voiceList$ | async); as voiceList) {
  <app-datatable
    [columns]="columns"
    [data]="voiceList"
    [totalCount]="voiceList.length"
    [tableTools]="tableTools"
    [pageIndex]="voiceService.pageIndex"
    [pageSize]="voiceService.pageSize"
    [cordX]="voiceService.cordX"
    [cordY]="voiceService.cordY"
    [selectedId]="voiceService.selectedId"
    [searchParam]="voiceService.searchParam"
    showIndexColumn="true"
    (editItemEvent)="editVoice($event)" (cloneItemEvent)="cloneVoice($event)"
    (deleteItemEvent)="deleteVoice($event)"
    (refreshEvent)="voiceService.refresh()"
    (pageChangingEvent)="pageChangeEvent($event)"
    (searchParamEvent)="searchParamEvent($event)"
    name="Voice">
  </app-datatable>
}

